import { Component, OnInit, inject } from '@angular/core';
import {TexteAdministrable} from '../../../class/api/TexteAdministrable';
import {api} from '../../../api/api-dictionnary';
import {HydraService} from '../../../core/services/hydra.service';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { SafeHtmlPipe } from '../../../pipes/safeHtml.pipe';

@Component({
    selector: 'app-modal-politique-protection-donnees',
    templateUrl: './modal-politique-protection-donnees.component.html',
    styleUrls: ['./modal-politique-protection-donnees.component.scss'],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatDialogActions, MatDialogClose, TranslateModule, SafeHtmlPipe]
})
export class ModalPolitiqueProtectionDonneesComponent implements OnInit {
    private hydraService = inject(HydraService);
    dialogRef = inject<MatDialogRef<ModalPolitiqueProtectionDonneesComponent>>(MatDialogRef);
    private translateService = inject(TranslateService);
    data = inject(MAT_DIALOG_DATA);

    charte: TexteAdministrable = null;
    public texte: string = null;


    ngOnInit() {
        this.getCharte();
    }

    public getCharte() {
        this.hydraService
            .getById(api.TexteAdministrables + '/document_politique_protection_donnees')
            .subscribe((res: TexteAdministrable) => {
                if (res) {
                    this.charte = res;
                }
                let locale = '';

                let currentLanguage = 'fr';
                if(this.translateService.currentLang) {
                    currentLanguage = this.translateService.currentLang;
                }
                res.translations.map(item => {
                    if (item.locale == currentLanguage) {
                        locale = item.locale;
                        this.texte = item.texte;
                    }
                });

                return this.texte;
            });
    }
}
